export default __webpack_public_path__ + "static/media/ic_ethereum_40.6b8ed3df.png";